<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: relative;margin-top: 20px;">
    @if (!confirmar) {
      <div class="close-dialog" mat-dialog-close>
        <span class="material-symbols-outlined">close</span>
      </div>
    }
  </div>
</div>



<mat-dialog-content>

  <div style="text-align: center;">

    @if (confirmar) {
      <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
        <span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color7)">check_circle</span>
      </div>
    }

    @if (!confirmar) {
      <div class="label-dialog-title">¡Estás a punto de rechazar las condiciones!</div>
    }
    @if (!confirmar) {
      <div class="label-dialog">Si lo haces, la operación será</div>
    }
    @if (!confirmar) {
      <div class="label-dialog">descartada de forma definitiva.</div>
    }

    @if (confirmar) {
      <div class="label-dialog-title">¡Rechazo de condiciones confirmado!</div>
    }
    @if (confirmar) {
      <div class="label-dialog">Tu ejecutivo te contactará para conversar y conocer</div>
    }
    @if (confirmar) {
      <div class="label-dialog">las razones. Queremos escucharte y asesorarte.</div>
    }


    @if (!confirmar) {
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            <button class="primary-button" mat-flat-button mat-dialog-close>
              Cancelar
            </button>
            <button class="secondary-button" mat-flat-button (click)="rechazar()">
              Rechazar
            </button>
          </div>
        </div>
      </div>
    }

    @if (confirmar) {
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            <button class="primary-button" mat-flat-button mat-dialog-close routerLink="/home">
              Volver al inicio
            </button>
          </div>
        </div>
      </div>
    }

  </div>



</mat-dialog-content>